<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import colourEnum from '../enums/colour'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                containerForm: () => import('../forms/ContainerForm'),
                floralVarietyForm: () => import('../forms/FloralVarietyForm'),
                memberForm: () => import('../forms/MemberForm'),
                packerContainerFileForm: () => import('../forms/PackerContainerFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Container', value: 'containerId', rules: [v => !!v || 'Container is required'], isRequired: true, form: () => import('./ContainerForm'), apiMethod: 'Containers', claim: 'Containers' },
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'datetime', text: 'Sampled On', value: 'sampledOn', rules: [v => !!v || 'Sampled On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Floral Variety', value: 'floralVarietyId', rules: [v => !!v || 'Floral Variety is required'], isRequired: true, form: () => import('./FloralVarietyForm'), apiMethod: 'FloralVarieties', claim: 'FloralVarieties' },
                    { type: 'enum', text: 'Colour', value: 'colour', rules: [v => (v !== null && v !== '') || 'Colour is required'], isRequired: true, items: enumService.enumAsSelectList(colourEnum) },
                    { type: 'text', text: 'Odour', value: 'odour', rules: [v => !(v && v.length > 100) || 'Odour must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'Taste', value: 'taste', rules: [v => !(v && v.length > 100) || 'Taste must be less than 100 characters'], maxLength: 100 },
                    { type: 'percentage', text: 'Moisture Percentage', value: 'moisturePercentage', rules: [v => (v !== null && v !== '') || 'Moisture Percentage is required'], isRequired: true },
                    { type: 'text', text: 'Inspected By', value: 'inspectedBy', rules: [v => !(v && v.length > 100) || 'Inspected By must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'Approved By', value: 'approvedBy', rules: [v => !(v && v.length > 100) || 'Approved By must be less than 100 characters'], maxLength: 100 },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'packerContainerId', form: () => import('../forms/PackerContainerFileForm') }
                ],
                apiMethod: 'PackerContainers',
                formTitle: 'Packer Container',
            }
        },
    };
</script>
